<div class="header">
  @if ($overridable()) {
    <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10.3 4.2 2.8 17.5A2 2 0 0 0 4.5 20.5h15a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 9.5v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17" r="1.2" fill="currentColor"/></svg>
  } @else {
    <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 7.5v5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="16.5" r="1.2" fill="currentColor"/></svg>
  }
  <div class="title">{{ $content().title }}</div>
</div>
@if ($content().intro) {
  <div class="intro">{{ $content().intro }}</div>
}
<div class="rows">
  @for (row of $content().rows; track row.key) {
    <div class="row" [class.unchanged]="row.tone === unchanged">
      <span class="name">{{ row.name }}@if (row.tag) {<w-badge size="small" severityBadge="neutral" [severityBadgeLabel]="row.tag" />}</span>
      <span class="detail" [class.attention]="row.tone === attention">{{ row.detail }}</span>
    </div>
  }
</div>
<div class="guidance">{{ $content().guidance }}</div>
@if ($overridable()) {
  <div class="opt-in"><ng-content /></div>
}
